 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationSort',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#reservationsort-sort_by').on('change', function click(e)
		{
			var $form = $(this).closest('form');

			$form.submit();
		});
	};
}(jQuery, window.Adzuki || {}));
